/**
 * Stable CSS class names for E2E — Customer store orders paper.
 */
export const CSOP = {
    page: 'customer-store-orders-paper-page',
    header: 'customer-store-orders-paper__header',
    searchRow: 'customer-store-orders-paper__search-row',
    inputOrderNumberSearch: 'customer-store-orders-input--order-number-search',
    mainPaper: 'customer-store-orders-paper__main-paper',
    tableSection: 'customer-store-orders-paper__table-section',
    tableContainer: 'customer-store-orders-paper__table-container',
    inputIconButtonExpandRow: 'customer-store-orders-input--icon-button-expand-row',
    inputLinkViewReceipt: 'customer-store-orders-input--link-view-receipt',
    expandedPanel: 'customer-store-orders-paper__expanded-panel',
    productRow: 'customer-store-orders-paper__product-row',
    paymentSection: 'customer-store-orders-paper__payment-section',
    summarySection: 'customer-store-orders-paper__summary-section',
} as const;
